import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Fieldset } from "primereact/fieldset";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import QuestionarioSeplag from "../../../../components/QuestionarioSeplag";
import RotuloSeplag from "../../../../components/RotuloSeplag";
import { printToast } from "../../../../config/global";
import {
  buscarApuracaoByIndenIndicador,
  buscarMetaPPA,
  buscarQuestionarioIndicador,
  salvarApuracaoIndicador,
  salvarAvaliacaoIndicador,
} from "../../../../service/Rag/AvaliacaoPrograma";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";

const AvaliacaoProgramaRagIndicador = (props) => {
  const user = useSelector((state) => state.userReducer.user);

  const [listaObjetivos] = useState([...props.dadosItemPrograma.dadosItemRag.objetivos]);
  const [objetivoSelecionado, setObjetivoSelecionado] = useState([]);

  const [listaIndicadores, setListaIndicadores] = useState(null);
  const [indicadorSelecionado, setIndicadorSelecionado] = useState(null);

  const [dadosApuracao, setDadosApuracao] = useState(getDadosApuracaoDefault());
  const [dadosMetaPPA, setDadosMetaPPA] = useState();
  const [questionarioIndicador, setQuestionarioIndicador] = useState();

  const [podeAvaliarIndicador, setPodeAvaliarIndicador] = useState(false);

  const [isValidDate, setIsValidDate] = useState(true);
  const toast = useRef(null);

  let history = useHistory();

  function getDadosApuracaoDefault() {
    return {
      idenApuracaoIndicador: null,
      valorApuradoFormatado: null,
      valrApurado: null,
      dataApuracao: null,
      indicador: { idenIndicador: null },
    };
  }

  function onChangeObjetivo(obj) {
    setListaIndicadores(obj.value?.indicadores.length > 0 ? obj.value.indicadores : []);
    setObjetivoSelecionado(obj.value ? obj.value : null);
    setIndicadorSelecionado(null);
    setDadosApuracao(getDadosApuracaoDefault());
  }

  async function onChangeIndicador(e) {
    setIndicadorSelecionado(null);
    setDadosMetaPPA(null);
    setIndicadorSelecionado(e.value ? e.value : null);
    setDadosApuracao(getDadosApuracaoDefault());
    buscarDadosApuracao(e.value);
  }

  async function buscarDadosApuracao(indicador) {
    if (indicador && indicador.idenIndicador) {
      await buscarApuracaoByIndenIndicador(indicador.idenIndicador).then((res) => {
        setDadosApuracao({ ...res.data });
      });
      await buscarMetaPPA(
        objetivoSelecionado.idenObjetivo,
        indicador.idenIndicador,
        props.dadosItemPrograma.dadosItemRag.idenPrograma
      ).then((resMeta) => {
        setDadosMetaPPA(resMeta.data);
      });
      await buscarQuestionarioIndicador(indicador.idenIndicador).then((resQuest) => {
        montarQuestionario(resQuest.data.questionarioRag);
        let flagCheckAvaliaIndicador = false;
        if (
          resQuest.data.dadosItemRag.isProrrogaAvaliacao === "S" &&
          props.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa
        ) {
          flagCheckAvaliaIndicador = true;
        }

        if (resQuest.data.dadosItemRag.isProrrogaAvaliacao === "N" && props.podeAvaliarIndicador) {
          flagCheckAvaliaIndicador = true;
        }

        setPodeAvaliarIndicador(flagCheckAvaliaIndicador);
      });
    }
  }

  const selectedObjetivoTemplate = (option, props) => {
    if (option) {
      return (
        <div>
          <div>{option.codgObjetivo + " - " + option.nomeObjetivo}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  function montarQuestionario(questionario) {
    let questIndicador = mapQuestionario(
      questionario.filter((questP) => questP.descCategoriaPergunta === "indicadores")
    );
    setQuestionarioIndicador(questIndicador);
  }

  function mapQuestionario(qmap) {
    let retorno = qmap
      .map((questao) => {
        return {
          ...questao,
          id: questao.rowId,
          label: `${questao.numrPergunta} - ${questao.descPergunta}`,
          data: questao.valrRespostaItemQuest,
          type: questao.siglTipoPergunta,
          options: questao.opcoes.split("/").map((opcao) => {
            return {
              code: opcao,
              name: opcao,
            };
          }),
        };
      })
      .sort((a, b) => {
        return a.numrOrdemPergunta - b.numrOrdemPergunta;
      });
    return retorno;
  }

  const selectedIndicadorTemplate = (option, props) => {
    if (option) {
      return (
        <div>
          <div>{option.codgIndicador + " - " + option.descIndicador}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const salvar = async () => {
    const validacaoErro = validarCampos();
    if (validacaoErro) {
      printToast({
        severity: "error",
        detail: validacaoErro,
      });
      return;
    }

    await salvarApuracao();

    if (questionarioIndicador !== undefined) {
      let v_campos = questionarioIndicador.map((questao) => {
        questao.valrRespostaItemQuest = questao.data;
        return { ...questao };
      });

      let idenIndicador = indicadorSelecionado.idenIndicador;

      await salvarAvaliacaoIndicador(idenIndicador, v_campos).then((res) => {
        //setQuestionarioIndicador(v_campos);
      });
    }

    await buscarDadosApuracao(indicadorSelecionado);
  };

  function validarCampos() {
    let qtdRealizadoNum = dadosApuracao.valorApuradoFormatado ? dadosApuracao?.valorApuradoFormatado : null;
    qtdRealizadoNum = parseFloat(qtdRealizadoNum);

    let body = {
      idenApuracaoIndicador:
        dadosApuracao && dadosApuracao.idenApuracaoIndicador != null ? dadosApuracao.idenApuracaoIndicador : null,
      indicador: {
        idenIndicador: indicadorSelecionado.idenIndicador,
      },
      dataApuracao: dadosApuracao?.dataApuracao !== "" ? dadosApuracao.dataApuracao : null,
      valrApurado: qtdRealizadoNum,
    };

    if (!body.dataApuracao) {
      return "A ‘Data da Apuração’ do Indicador deve ser informada";
    }

    if (questionarioIndicador !== undefined) {
      let v_campos = questionarioIndicador.map((questao) => {
        questao.valrRespostaItemQuest = questao.data;
        return { ...questao };
      });

      const questaoSemResposta = v_campos.find(
        (questao) =>
          questao.flagObrigatorio === "S" &&
          (questao.valrRespostaItemQuest === null || questao.valrRespostaItemQuest === undefined)
      );

      if (questaoSemResposta) {
        return `Informe uma resposta para a questão ‘${questaoSemResposta.numrPergunta}’ dessa tela`;
      }
    }

    if (!body.valrApurado) {
      return "O valor ‘Realizado’ (Apuração) do Indicador deve ser informado";
    }

    return null;
  }

  async function salvarApuracao() {
    //   let qtdRealizadoNum = dadosApuracao.valorApuradoFormatado ? dadosApuracao.valorApuradoFormatado : null;
    // qtdRealizadoNum = parseFloat(qtdRealizadoNum);

    let body = {
      idenApuracaoIndicador:
        dadosApuracao && dadosApuracao.idenApuracaoIndicador != null ? dadosApuracao.idenApuracaoIndicador : null,
      indicador: {
        idenIndicador: indicadorSelecionado.idenIndicador,
      },
      dataApuracao: dadosApuracao?.dataApuracao !== "" ? dadosApuracao.dataApuracao : null,
      valrApurado:
        typeof dadosApuracao?.valorApuradoFormatado === "string"
          ? Number(dadosApuracao.valorApuradoFormatado.replace(/\./g, "").replace(",", "."))
          : Number(dadosApuracao?.valorApuradoFormatado ?? 0),
    };

    if (!body.valrApurado || !body.dataApuracao) {
      return;
    }

    await salvarApuracaoIndicador(body).then((res) => {
      printToast({ summary: "Ação Efetuada", detail: "Avaliação do indicador salva com sucesso" });
    });
  }

  const salvarDadosAtualizados = (e) => {
    //setCamposQuestionarioSugestao(JSON.stringify(e));
    setQuestionarioIndicador(e);
  };

  const formartNumber = ({ valrMetaIndicadorObjetivo, descUnidadeMedida }) => {
    if (valrMetaIndicadorObjetivo >= 0) {
      if (descUnidadeMedida === "Percentual") {
        return (
          Number(valrMetaIndicadorObjetivo).toLocaleString("pt-BR", {
            style: "decimal",
            minimumFractionDigits: 2,
          }) + "%"
        );
      } else {
        return Number(valrMetaIndicadorObjetivo).toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 2,
        });
      }
    }

    return "Não informado";
  };

  const validateDate = (value) => {
    const [day, month, year] = value.split("/");

    const dayInt = parseInt(day, 10);
    const monthInt = parseInt(month, 10);
    const yearInt = parseInt(year, 10);

    // Verifica se os valores são números válidos e dentro dos limites de dias, meses e anos
    if (isNaN(dayInt) || isNaN(monthInt) || isNaN(yearInt)) {
      return false;
    }

    if (dayInt < 1 || dayInt > 31 || monthInt < 1 || monthInt > 12 || yearInt < 1000 || yearInt > 9999) {
      return false;
    }

    // Verifica a quantidade de dias em cada mês (considera ano bissexto para fevereiro)
    const daysInMonth = new Date(yearInt, monthInt, 0).getDate();
    return dayInt <= daysInMonth;
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setDadosApuracao({ ...dadosApuracao, dataApuracao: e.target.value });

    // Valida a data
    if (newValue.length === 10) {
      // Só valida quando a máscara está completa
      setIsValidDate(validateDate(newValue));
    } else {
      setIsValidDate(true); // Evita marcar como inválido enquanto o usuário está digitando
    }
  };

  return (
    <>
      <CardSeplagScrol title="Apuração dos Indicadores">
        <div className="p-fluid grid">
          <div className="field col-12">
            <RotuloSeplag nome="Objetivo do Programa">
              <Dropdown
                emptyMessage="Dados não encontrados"
                itemTemplate={selectedObjetivoTemplate}
                valueTemplate={selectedObjetivoTemplate}
                emptyFilterMessage="Opção não encontrada"
                id="selObjetivo"
                value={objetivoSelecionado}
                options={listaObjetivos}
                onChange={(e) => onChangeObjetivo(e)}
                optionLabel="nomeObjetivo"
                filter
                filterBy="nomeObjetivo"
                placeholder="Selecione um objetivo"
              />
            </RotuloSeplag>
          </div>
          {objetivoSelecionado !== null && (
            <div className="field col-12">
              <RotuloSeplag nome="Indicador">
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  itemTemplate={selectedIndicadorTemplate}
                  valueTemplate={selectedIndicadorTemplate}
                  emptyFilterMessage="Opção não encontrada"
                  id="selIndicador"
                  value={indicadorSelecionado}
                  options={listaIndicadores}
                  onChange={(e) => onChangeIndicador(e)}
                  optionLabel="descIndicador"
                  filter
                  filterBy="descIndicador"
                  placeholder="Selecione um Indicador"
                />
              </RotuloSeplag>
            </div>
          )}
          {indicadorSelecionado !== null && (
            <>
              <div className="field col-1">
                <RotuloSeplag nome="Código:">
                  <label>{indicadorSelecionado?.codgIndicador}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-2">
                <RotuloSeplag nome="Fonte de apuração:">
                  <label>{indicadorSelecionado?.descFonteApuracao}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-3">
                <RotuloSeplag nome="Período de apuração:">
                  <label>{indicadorSelecionado?.flagPeriodicidade}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-3">
                <RotuloSeplag nome="Unidade de medida:">
                  <label>
                    {indicadorSelecionado?.unidadeMedida ? indicadorSelecionado?.unidadeMedida?.descUnidadeMedida : ""}
                  </label>
                </RotuloSeplag>
              </div>
              <div className="field col-3">
                {indicadorSelecionado?.exercicio.ano >= 2024 && (
                  <RotuloSeplag nome="Sentido/Polaridade:">
                    <label>{indicadorSelecionado?.descPolaridade ? indicadorSelecionado?.descPolaridade : ""}</label>
                  </RotuloSeplag>
                )}
              </div>
              <div className="field col-3">
                <RotuloSeplag nome="Base Geográfica:">
                  <label>{indicadorSelecionado?.flagBaseGeografica}</label>
                </RotuloSeplag>
              </div>
              <div className="field col-9">
                {indicadorSelecionado?.exercicio.ano >= 2024 ? (
                  <RotuloSeplag nome="Fórmula de cálculo do Indicador:">
                    <label>{indicadorSelecionado?.descFormulaCalculo}</label>
                  </RotuloSeplag>
                ) : (
                  <RotuloSeplag nome="Indíce do PPA:">
                    <label>{indicadorSelecionado?.descFormulaCalculo}</label>
                  </RotuloSeplag>
                )}
              </div>
              <Fieldset legend="Apuração do Indicador" className="field col-12">
                <div className="p-fluid grid">
                  <div className="field col-6">
                    <RotuloSeplag nome="Descrição:">
                      <label>{indicadorSelecionado?.codgIndicador + " - " + indicadorSelecionado?.descIndicador}</label>
                    </RotuloSeplag>
                  </div>
                  <div className="field col-2">
                    <RotuloSeplag nome="Previsto:">
                      <label>
                        {formartNumber({
                          valrMetaIndicadorObjetivo: dadosMetaPPA?.valrMetaIndicadorObjetivo,
                          descUnidadeMedida: indicadorSelecionado?.unidadeMedida?.descUnidadeMedida,
                        })}
                      </label>
                    </RotuloSeplag>
                  </div>
                  <div className="field col-2">
                    <RotuloSeplag obrigatorio nome="Realizado:">
                      <InputNumber
                        inputId="locale-br"
                        locale="pt-BR"
                        minFractionDigits={2}
                        value={
                          typeof dadosApuracao?.valorApuradoFormatado === "string"
                            ? Number(dadosApuracao.valorApuradoFormatado.replace(/\./g, "").replace(",", "."))
                            : Number(dadosApuracao?.valorApuradoFormatado ?? 0)
                        }
                        onChange={(e) => {
                          if (e.value == null || e.value == undefined) {
                            return setDadosApuracao({ ...dadosApuracao, valorApuradoFormatado: 0 });
                          }
                          // let valorFormatado = e.value.toLocaleString("pt-BR", {
                          //   minimumFractionDigits: 2,
                          // });
                          setDadosApuracao({ ...dadosApuracao, valorApuradoFormatado: e.value });
                        }}
                        disabled={!podeAvaliarIndicador}
                      />
                    </RotuloSeplag>
                  </div>
                  <div className="field col-2">
                    <RotuloSeplag obrigatorio nome="Data da Apuração:">
                      <InputMask
                        value={dadosApuracao?.dataApuracao}
                        onChange={handleChange}
                        mask="99/99/9999"
                        slotChar="__/__/____"
                        placeholder="__/__/____"
                        id="dataApuracao"
                        disabled={!podeAvaliarIndicador}
                        className={isValidDate ? "" : "p-invalid"}
                      />
                      {!isValidDate && <small className="p-error">Data inválida</small>}
                    </RotuloSeplag>
                  </div>
                </div>
              </Fieldset>
              {questionarioIndicador &&
                (indicadorSelecionado?.exercicio.ano >= 2024 ? (
                  <div className="field col-12 ">
                    <QuestionarioSeplag
                      cols="12"
                      campos={questionarioIndicador}
                      setCampos={salvarDadosAtualizados}
                      condicao={props.condicao}
                      IsMaximoCaracteres={true}
                      qtdMaxCaracteres={10000}
                      isDisabled={!podeAvaliarIndicador}
                    ></QuestionarioSeplag>
                  </div>
                ) : (
                  <div className="field col-12 ">
                    <QuestionarioSeplag
                      cols="12"
                      campos={questionarioIndicador}
                      setCampos={salvarDadosAtualizados}
                      condicao={props.condicao}
                      IsMaximoCaracteres={true}
                      qtdMaxCaracteres={4000}
                      isDisabled={!podeAvaliarIndicador}
                    ></QuestionarioSeplag>
                  </div>
                ))}
              <br />
              <br />
              <div className="field col-12 md:col-8 ">&nbsp;</div>
              <div className="field col-12 md:col-2 ">
                <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
              </div>
              <div className="field col-12 md:col-2 ">
                <Button label="Salvar" className="p-button-success" onClick={salvar} disabled={!podeAvaliarIndicador} />
              </div>
              {/*<div className="field col-12 md:col-2 ">
                        <Button label="Remover" className="p-button-danger"  onClick={remover} />
                    </div>*/}
            </>
          )}
        </div>
      </CardSeplagScrol>
    </>
  );
};
export default AvaliacaoProgramaRagIndicador;
